import axios from 'axios';
import '../helpers/api_helper';
import { api } from '../config';

const BASE = api.API_URL;

export const getIaResumen = ({ screen, empresa, year, snapshot }) =>
    axios.post(`${BASE}/ia/resumen`, { screen, empresa, year, snapshot });
